<template>
  <div id="PostButton">
    <v-btn fab dark large color="red" :to="{name: 'Edit', params: {obj: {mode: 'new'}}}">
      <v-icon dark>edit</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'PostButton',
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
  },
  components: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url("../../assets/css/common.css");

#PostButton{
  position: fixed;
  z-index: 100;
  bottom: 10px;
  right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/PostButton.vue